import React from 'react'
import { Formik, Form as FormikForm } from 'formik'
import Form from '@components/Common/Form'
import Button from '@components/Common/Button'
import Select from '@components/Common/Select'
import ButtonGroup from '@components/Common/Button/Group'
import selectBloqueado from '@constants/select/bloqueado'
import { ModalProps } from '@interfaces/Modal'
import { saveVeiculoBloqueado } from '@modules/viagem/controllers/viagemController'
import { useAppDispatch, useAppSelector } from '@redux/hooks'

const FormVeiculoBloqueado: React.FC<ModalProps> = props => {

    const dispatch = useAppDispatch()
    const { currentViagemAtiva } = useAppSelector(s => s.viagem)
    const { requestUpdateViagem } = useAppSelector(s => s.requestViagem)
    const { userData } = useAppSelector(s => s.auth)


    return (

        <>
            {!!currentViagemAtiva && (
                <Formik
                    initialValues={{
                        id: currentViagemAtiva.id,
                        flagVeiculoBloqueado: currentViagemAtiva.flagVeiculoBloqueado,
                        obsVeiculoBloqueado: currentViagemAtiva.obsVeiculoBloqueado,
                        idUsuarioFinalizado: userData?.id
                    }}
                    onSubmit={v => {
                        saveVeiculoBloqueado(dispatch, v, props)
                    }}
                >
                    {({ values, setFieldValue }) => (
                        <FormikForm>
                            <Form.Container padding={false}>
                                <Form.Section>
                                    <Form.Row columns={1} grid="1fr">
                                        <Select
                                            type="outline"
                                            label="Bloqueio T4/3S"
                                            fieldName="flagVeiculoBloqueado"
                                            value={values.flagVeiculoBloqueado}
                                            items={selectBloqueado}
                                            setFieldValue={setFieldValue}
                                        />
                                        <Form.Group
                                            label="Observações"
                                            inputType="textarea"
                                            inputID="obsVeiculoBloqueado"
                                            inputName="obsVeiculoBloqueado"
                                        />
                                    </Form.Row>
                                </Form.Section>
                                <ButtonGroup>
                                    <Button
                                        label="Fechar"
                                        onClick={() => props.setOpen(false)}
                                    />
                                    <Button
                                        type="submit"
                                        status="success"
                                        loading={requestUpdateViagem.loading}
                                        label="Salvar"
                                    />
                                </ButtonGroup>
                            </Form.Container>
                        </FormikForm>
                    )}
                </Formik>
            )}
        </>

    )

}

export default FormVeiculoBloqueado